import React from "react"

import { AppCategoriesAutocomplete } from "@components/Autocomplete"
import { BACKEND_APIS } from "@constants"
import { categories, disableButton, errors } from "@signals"
import { chainFinish } from '@components/NewCommonFilters/@services/chainFinish'


export default function AppCommonFiltersCategoriesAutocomplete({ onOptions, ...props }) {
	return <AppCategoriesAutocomplete
		value={categories.value}
		error={errors.value?.categoryID}
		onChange={e => categories.value = e.target.value}
		onFinishAjax={chainFinish(() => disableButton.value = false, onOptions)}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/categories`}
		{...props}
	/>
}